import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';
import './Navbar.css'
import SideNav from '../../SideNav/SideNav'
import FlashingAd from './FlashingAd';
import { useAuth } from '../../../auth/AuthContext'

const Navbar = () => {
    const { user, profile, signOut } = useAuth()
    const [adConfig, setAdConfig] = useState({
        enabled: false,
        message: '',
        href: 'https://app.squareup.com/gift/ML6SGAZMY5MN0/order',
        caption: '',
        colorCycle: ['flash-red', 'flash-blue', 'flash-pink']
    })
    const logout = async () =>{
        await signOut()
        window.location.replace('/')
    }

    useEffect(() => {
        let isMounted = true;

        fetch(`${process.env.PUBLIC_URL}/content/home.json`)
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (isMounted && data?.flashingAd) {
                    setAdConfig((current) => ({
                        ...current,
                        ...data.flashingAd,
                        colorCycle: data.flashingAd.colorCycle || current.colorCycle
                    }));
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    const toggleSideNav = () =>{
        let sideNavbar = document.querySelector('.side-navbar')
        let humburger = document.querySelectorAll('.line')
        sideNavbar.classList.toggle('side-navbar-avtive')

        humburger.forEach((line)=>{
            line.classList.toggle('humburger-active')
        })
    }

    return (
        <div>
            <SideNav/>
            <div className='navbar'>
                <h1 onClick={()=>window.location.replace('/')} className='navbar-logo'>
                    The Nail Lab
                </h1>
                <ul className='navbar-ul'>
                    <li className='nav-items'>
                        <a href="https://nail-labs.square.site/" className='links'>About Us</a>
                    </li>
                    <li className='nav-items'>
                        <a href="./#what-we-do" className='links'>Service</a> 
                    </li>
                    {profile?.role === 'admin' ? (
                        <li className='nav-items'>
                            <Link className='links cp' to='/admin'>
                                Control Panel
                            </Link>
                        </li>
                    ) : null}
                    {user ? (
                        <li className='nav-items'>
                            <Link className='links up' to='/profile'>
                                User Profile
                            </Link>
                        </li>
                    ) : null}
                </ul>

                <FlashingAd
                    enabled={adConfig.enabled}
                    message={adConfig.message}
                    href={adConfig.href}
                    caption={adConfig.caption}
                    colorCycle={adConfig.colorCycle}
                />

                {user ? (
                    <div className='user-loggedIn'>
                        <span className='user-role'>
                            {profile?.name || 'User'} ({profile?.role || 'client'})
                        </span>
                        <button className='disappear' onClick={logout}>Logout</button>
                    </div>
                ) : (
                    <div className='login-reg-links'>
                        <Link className='login-link' to='/login'>Login</Link>
                        <div
                        className='date-and-phone'
                        onClick={() => window.location.href = 'https://nail-labs.square.site/home#location-and-hours'}
                        role="button"
                        tabIndex={0}
                        aria-label="Contact us!"
                        >
                            <div>
                                <i className="fa fa-phone" aria-hidden="true"></i>
                                <label> (301) 603-2909 </label>
                            </div>
                        </div>
                    </div>
                )}

            
                <div onClick={toggleSideNav} className="humburger">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>
        </div>

    )

}

export default Navbar
